import { render, staticRenderFns } from "./deliveryProofList.vue?vue&type=template&id=5c25e3f5&scoped=true&"
import script from "./deliveryProofList.vue?vue&type=script&lang=js&"
export * from "./deliveryProofList.vue?vue&type=script&lang=js&"
import style0 from "./deliveryProofList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./deliveryProofList.vue?vue&type=style&index=1&id=5c25e3f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c25e3f5",
  null
  
)

export default component.exports